import { IGetProjetoArquivoByIdUseCase } from "../../../presentation/useCases/read/get_projeto_arquivo_by_id_use_case";
import { GetProjetoArquivoByIdRequestModel } from "../../models/projeto_arquivo_model";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class GetProjetoArquivoByIdUseCase implements IGetProjetoArquivoByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getProjetoArquivoById(request: GetProjetoArquivoByIdRequestModel): Promise<void> {
    const blob = await this.repository.getProjetoArquivoById(request);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(request.imageName));
    document.body.appendChild(link);
    link.click(); 
    
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
